import React, { FC } from "react";
import { IconButton, IconButtonProps } from "@mui/material";
import { Close } from "@mui/icons-material";

export const CloseIconButton: FC<IconButtonProps> = (props) => (
  <IconButton {...props}>
    <Close />
  </IconButton>
);

